import { Route, Routes } from "react-router-dom";
import { HomePage } from './pages/HomePage';
import { ResultSearchPage } from './pages/ResultSearchPage';
import { CallbackPage } from "./pages/CallbackPage";
import { ProfilePage } from "./pages/ProfilePage";
import { GamesPage } from "./pages/GamesPage";
import { ResultPage } from "./pages/ResultPage";
import { GamePage } from "./pages/GamePage";
import { LoginPage } from './pages/LoginPage';
import { SurveysPage } from './pages/SurveysPage';
import { SurveyPage } from './pages/SurveyPage';

function App() {
	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/login" element={<LoginPage />} />
			<Route path="/callback" element={<CallbackPage />} />
			<Route path="/profile" element={<ProfilePage />} />
			<Route path="/games" element={<GamesPage />} />
			<Route path="/result" element={<ResultSearchPage />} />
			<Route path="/result/:code" element={<ResultPage/>} />
			<Route path="/game/:symbolicId" element={<GamePage/>} />
			<Route path="/surveys" element={<SurveysPage/>} />
			<Route path="/survey/:symbolicId" element={<SurveyPage/>} />
		</Routes>
	);
      }
      
export default App;